const initialState = {
    logFazendaSinc: [],
    idFazenda: 0,
    fazenda: '',
    empresa: '',
    dias: '',
    ultimaAlteracao: ''
};

export function logFazendaSinc(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_LOG_FAZENDA_SINC':
            return {
                ...state,
                logFazendaSinc: action.logFazendaSinc
            };
        case 'LOG_FAZENDA_SINC_DETAIL':
            return {
                ...state,
                idFazenda: action.idFazenda,
                fazenda: action.fazenda,
                empresa: action.empresa,
                dias: action.dias,
                ultimaAlteracao: action.ultimaAlteracao
            };
        case "LOG_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE_LOG_FAZENDA_SINC":
            return {
                ...state,
                [action.props]: action.value
            };
        default:
            return state
    }
}
